import React, {StrictMode} from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './src/assets/css/index.css'
import "react-datepicker/dist/react-datepicker.css";

ReactDOM.createRoot(document.getElementById('root')).render(
      <App />
)
